import { render, staticRenderFns } from "./student-notice.vue?vue&type=template&id=7236b6e2&"
import script from "./student-notice.vue?vue&type=script&lang=js&"
export * from "./student-notice.vue?vue&type=script&lang=js&"
import style0 from "./student-notice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports